import { Injectable } from '@angular/core';

import { Observable, map, tap } from 'rxjs';

import { StoreConfiguration } from '@hdms/shared/common-types';
import { UserContextService, getLocalization } from '@hdms/shared/data-access';
import { EnvironmentService } from '@hdms/shared/util-core';

import { FavoritesConfigurationGqlService } from './favorites-configuration-gql.service';

@Injectable({
  providedIn: 'root'
})
export class AccessService {
  private storeConfig: StoreConfiguration;

  constructor(
    private readonly configurationGqlService: FavoritesConfigurationGqlService,
    private readonly envService: EnvironmentService,
    private readonly userContextService: UserContextService
  ) {}

  getData$(): Observable<boolean> {
    return this.configurationGqlService.fetch({ localization: getLocalization(this.envService) }).pipe(
      map(({ data }) => data),
      tap(({ storeConfiguration }) => {
        this.storeConfig = storeConfiguration;
      }),
      map(_ => true)
    );
  }

  isSubmittalsEnabled(): boolean {
    return this.storeConfig?.common?.fireStopSubmittals;
  }

  isRecommendationsEnabled(): boolean {
    return this.storeConfig?.common?.recommendedProducts;
  }

  isLastPurchasesEnabled(): boolean {
    return this.storeConfig?.common?.recentlyPurchasedItems;
  }

  getAccountId(): string {
    return this.userContextService.account.originId;
  }

  getContactId(): string {
    return this.userContextService.contact.originId;
  }
}
